export default {
	namespaced: true,
	state: {
		// ms
		TRANSITION_SPEED: 200, // common.css에 --transition-default 값과 동기화 시켜야함
		AXIOS_TIMEOUT: 30000, // 최대 30초
	},
	mutations: {},
};